module.exports = __webpack_public_path__ + "img/waveImage.fe40d176.png";